import intl from "react-intl-universal";

import {IDataClientService} from "../../platform/services/data/DataClientService";
import {IAuthService} from "../../platform/services/auth/AuthService";
import {snackBarRef} from "../../stores/snackbarRef";
import {AuditTemplateGqlProvider} from "../../stores/audit/AuditTemplateGqlProvider";
import type {AuditTemplate} from "../../stores/audit/types";

export const unpublishAudit = async (
    dataClientService: IDataClientService,
    authService: IAuthService,
    wsId: string,
    id: string,
): Promise<AuditTemplate> => {
    const provider = new AuditTemplateGqlProvider({dataClientService, authService}, wsId);
    const updated = await provider.update({id, publicationState: 'draft'});
    snackBarRef.current?.enqueueSnackbar({
        message: intl.get('audits.unpublish.success').d('Audit moved to draft'),
    });
    return updated;
};
